<Progress
    label={displayTextString}
    {max}
    {value}
    labelPosition={labelPosition}
/>

<script>
    import { formatLanguageString } from "@itslearning/atlas/strings/format";
    import Progress from "@itslearning/prometheus/assets/nodes/Progress/v1/Progress.svelte";

    export let labelPosition;
    export let value = 0;
    export let max;
    export let displayText = "{0}/{1}";

    $: displayTextString = formatLanguageString(displayText, value, max);
</script>
